import React from 'react'
import { useSnapshot } from 'valtio'
import UtopiaBottomSheetModal from './UtopiaBottomSheetModal'
import { UTOPIA_LEGAL_SECTIONS } from './utopiaLegalContent'
import { closeUtopiaLegalModal, openUtopiaLegalModal, utopiaOverlayState } from './utopiaOverlayState'
import { renderUtopiaModalParagraph } from './utopiaModalParagraph'
import styles from './utopiaLanding.module.css'

export { openUtopiaLegalModal }

export default function UtopiaLegalModal () {
  const { legalOpen } = useSnapshot(utopiaOverlayState)

  return (
    <UtopiaBottomSheetModal
      active={legalOpen}
      onClose={closeUtopiaLegalModal}
      title="Mentions légales"
      titleId="utopia-legal-title"
      subtitle="Serveur Minecraft Utopie"
    >
      {UTOPIA_LEGAL_SECTIONS.map(section => (
        <section key={section.title} className={styles.cguSection}>
          <h3 className={styles.cguSectionTitle}>{section.title}</h3>
          {section.paragraphs?.map((p, i) => (
            <p key={i} className={styles.cguParagraph}>{renderUtopiaModalParagraph(p)}</p>
          ))}
          {section.bullets && (
            <ul className={styles.cguList}>
              {section.bullets.map((b, i) => (
                <li key={i}>{renderUtopiaModalParagraph(b)}</li>
              ))}
            </ul>
          )}
        </section>
      ))}
    </UtopiaBottomSheetModal>
  )
}
